import * as Yup from 'yup';

export default Yup.object({
  reason: Yup.string().required('Please enter a reason'),
});
